<div class="container">
  <h1>Session Expired</h1>
  <p>
    Your session has been expired. To continue using the application, please log
    in again.
  </p>
  <thera-button
    [config]="{ variant: buttonVariant.PRIMARY, text: 'Log In' }"
    (click)="close()"
  ></thera-button>
</div>
